import { setSettings } from '@kelan-ui/vue/settings'

export default setSettings({
  theme: {
    radius: 0.75,
  },
  menu: {
    mode: 'head',
    mainMenuClickMode: 'smart',
  },
  topbar: {
    toolbar: false,
    mode: 'fixed',
  },
  toolbar: {
    breadcrumb: {
      style: 'modern',
    },
    fullscreen: true,
    pageReload: true,
    layout: [
      'favorites',
      'breadcrumb',
      '->',
      'i18n',
      'fullscreen',
      'pageReload',
      'menuSearch',
      'colorScheme',
    ],
  },
  page: {
    transitionMode: 'slide-right',
  },
})
